// Polyfill for Promise.withResolvers (required for pdfjs in older browsers)
if (!Promise.withResolvers) {
  Promise.withResolvers = function () {
    let resolve, reject
    const promise = new Promise((res, rej) => {
      resolve = res
      reject = rej
    })
    return { promise, resolve, reject }
  }
}

// Polyfill for URL.parse (required for pdfjs in older browsers)
if (!URL.parse) {
  URL.parse = function (url, base) {
    try {
      return new URL(url, base)
    } catch (e) {
      return null
    }
  }
}
